import type { ICompointsRatesMoney } from '@/modules/common/hooks/useCompPointsRatesMoney';

const MIN_EXCHANGE = 100;

export const maskNumber = (value: string) => {
  if (value == null || value === '') return '';
  return value.replace(/\D/g, '').replace(/^0*(\d+)/, '$1');
};

export const formatNumber = (num: number) => {
  if (Number.isInteger(num)) {
    return num.toString();
  }
  return Number.parseFloat(num.toFixed(4)).toString();
};

export const roundCompointsSum = (rate: number, compoints: number) =>
  Math.floor(compoints / rate) * rate;

export const getExchangeInfo = (
  compointsRatesMoney?: ICompointsRatesMoney[],
  chargeablePoints?: number
) => {
  const userCompoints = chargeablePoints || 0;

  const minExchange = compointsRatesMoney?.length
    ? compointsRatesMoney[0]?.rates[0].points
    : MIN_EXCHANGE;

  const isExchangeAvailable = !!(
    chargeablePoints !== undefined && compointsRatesMoney?.length
  );

  return { userCompoints, minExchange, isExchangeAvailable };
};
